import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';

export const getFooterResouceByMediaType = type => {
	const mediaType = type?.toLowerCase() || '';
	let footerText;
	let footerIcon;

	switch(mediaType) {
		case 'video': case 'online classes': case 'ptrxexercise':
			footerIcon = (<PlayCircleOutlineIcon fontSize="small" />);
			footerText = 'Video'
			break;
		case 'audio':
			footerIcon = (<VolumeUpOutlinedIcon fontSize="small" />);
			footerText = 'Audio'
			break;
		case 'letter': case 'activity': case 'self-care tool': case'self-care guide': case 'tip sheet':
			footerIcon = (<PictureAsPdfOutlinedIcon fontSize="small" />);
			footerText = 'PDF'
			break;
		case 'series':
			footerIcon = (<LibraryBooksOutlinedIcon fontSize="small"/>);
			footerText = 'Resources' 
			break;
		case 'article':
			footerIcon = (<ArticleOutlinedIcon fontSize="small"/>);
			footerText = 'Article'
			break;
		default:
			footerIcon = null
			footerText = null
			break;
	}
    return {footerText, footerIcon}
};
